export default function isFn(fn) {
  return (typeof fn === 'function')
}
